import { api } from "../lib/api";


function cleanParams(params = {}) {
  return Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) =>
        value !== undefined &&
        value !== null &&
        value !== ""
    )
  );
}


export const getStatus = () =>
  api
    .get("/gmao/status")
    .then((response) => response.data);


// acta_patch_us_gmao_020_installation_queue_v1
export const listPendingInstallations = (
  params = {}
) =>
  api
    .get(
      "/gmao/installations/pending",
      {
        params: cleanParams(params),
      }
    )
    .then((response) => response.data);


export const preparePurchaseOrderInstallation = (
  installationId,
  payload
) =>
  api
    .post(
      `/gmao/installations/${encodeURIComponent(
        installationId
      )}/prepare`,
      payload
    )
    .then((response) => response.data);


export const updateInstallationBankDeliveryApproval = (
  installationId,
  payload
) =>
  api
    .patch(
      `/gmao/installations/${encodeURIComponent(
        installationId
      )}/bank-delivery-approval`,
      payload
    )
    .then((response) => response.data);


export const uploadInstallationBankDeliveryApprovalDocument = (
  installationId,
  file
) => {
  const formData = new FormData();

  formData.append(
    "file",
    file
  );

  return api
    .post(
      `/gmao/installations/${encodeURIComponent(
        installationId
      )}/bank-delivery-approval/document`,
      formData
    )
    .then((response) => response.data);
};


export const getInstallationBankDeliveryApprovalDocumentBlob = (
  installationId
) =>
  api
    .get(
      `/gmao/installations/${encodeURIComponent(
        installationId
      )}/bank-delivery-approval/document/file`,
      {
        responseType: "blob",
      }
    )
    .then((response) => response.data);


export const listMachines = (params = {}) =>
  api
    .get(
      "/gmao/machines",
      {
        params: cleanParams(params),
      }
    )
    .then((response) => response.data);


export const listMachineAccessories = (machineId) =>
  api
    .get(
      `/gmao/machines/${encodeURIComponent(machineId)}/accessories`
    )
    .then((response) => response.data);


export const getMachineFleetMap = (
  params = {}
) =>
  api
    .get(
      "/gmao/machines/map",
      {
        params: cleanParams(params),
      }
    )
    .then((response) => response.data);


export const getMachine = (machineId) =>
  api
    .get(`/gmao/machines/${machineId}`)
    .then((response) => response.data);


export const getClientMachineWorkspace = (prospectId) =>
  api
    .get(
      `/gmao/machine-workspace/clients/${encodeURIComponent(
        prospectId
      )}`
    )
    .then((response) => response.data);


export const createMachineDeclaration = (payload) =>
  api
    .post(
      "/gmao/machine-workspace/declarations",
      payload
    )
    .then((response) => response.data);


export const validateMachineDeclaration = (declarationId) =>
  api
    .post(
      `/gmao/machine-workspace/declarations/${encodeURIComponent(
        declarationId
      )}/validate`
    )
    .then((response) => response.data);


export const getMachineClientContext = (machineId) =>
  api
    .get(
      `/gmao/machine-workspace/machines/${encodeURIComponent(
        machineId
      )}/client-context`
    )
    .then((response) => response.data);


export const getMachineAssignmentOptions = () =>
  api
    .get("/gmao/machine-workspace/assignment-options")
    .then((response) => response.data);


export const updateMachineAssignees = (machineId, payload) =>
  api
    .patch(
      `/gmao/machine-workspace/machines/${encodeURIComponent(
        machineId
      )}/assignees`,
      payload
    )
    .then((response) => response.data);


export const getMachineHistory = (
  machineId,
  limit = 200
) =>
  api
    .get(
      `/gmao/machines/${machineId}/history`,
      {
        params: {
          limit,
        },
      }
    )
    .then((response) => response.data);


export const getClientOptions = () =>
  api
    .get("/gmao/client-options")
    .then((response) =>
      Array.isArray(response.data?.items)
        ? response.data.items
        : []
    );


export const createQuickClient = (payload) =>
  api
    .post(
      "/gmao/clients/quick",
      payload
    )
    .then((response) => response.data);


export const createMachine = (payload) =>
  api
    .post(
      "/gmao/machines",
      payload
    )
    .then((response) => response.data);


export const updateMachine = (
  machineId,
  payload
) =>
  api
    .patch(
      `/gmao/machines/${machineId}`,
      payload
    )
    .then((response) => response.data);


export const assignMachineToClient = (
  machineId,
  payload
) =>
  api
    .patch(
      `/gmao/machines/${machineId}/assignment`,
      payload
    )
    .then((response) => response.data);


export const updateMachineStatus = (
  machineId,
  payload
) =>
  api
    .patch(
      `/gmao/machines/${machineId}/status`,
      payload
    )
    .then((response) => response.data);


// acta_patch_us_gmao_021_handpiece_lifecycle_v1
export const linkEquipmentParentMachine = (
  machineId,
  payload
) =>
  api
    .patch(
      `/gmao/machines/${encodeURIComponent(
        machineId
      )}/parent-machine`,
      payload
    )
    .then((response) => response.data);


// Alias conservé pour les workflows historiques de pièces à main.
export const linkHandpieceParentMachine =
  linkEquipmentParentMachine;


export const replaceHandpiece = (
  machineId,
  payload
) =>
  api
    .post(
      `/gmao/machines/${encodeURIComponent(
        machineId
      )}/replace-handpiece`,
      payload
    )
    .then((response) => response.data);


export const archiveMachine = (machineId) =>
  api
    .post(
      `/gmao/machines/${machineId}/archive`
    )
    .then((response) => response.data);


export const restoreMachine = (machineId) =>
  api
    .post(
      `/gmao/machines/${machineId}/restore`
    )
    .then((response) => response.data);


export const listInterventions = (params = {}) =>
  api
    .get(
      "/gmao/interventions",
      {
        params: cleanParams(params),
      }
    )
    .then((response) => response.data);


export const getIntervention = (
  interventionId
) =>
  api
    .get(
      `/gmao/interventions/${interventionId}`
    )
    .then((response) => response.data);


export const createIntervention = (payload) =>
  api
    .post(
      "/gmao/interventions",
      payload
    )
    .then((response) => response.data);


export const updateIntervention = (
  interventionId,
  payload
) =>
  api
    .patch(
      `/gmao/interventions/${interventionId}`,
      payload
    )
    .then((response) => response.data);


export const hideCancelledInterventionFromPlanning = (interventionId) =>
  api.delete(`/gmao/interventions/${encodeURIComponent(interventionId)}/planning`)
    .then((response) => response.data);

export const cancelIntervention = (
  interventionId,
  reason
) =>
  api
    .post(
      `/gmao/interventions/${interventionId}/cancel`,
      {
        reason,
      }
    )
    .then((response) => response.data);


export const getInterventionHistory = (
  interventionId
) =>
  api
    .get(
      `/gmao/interventions/${interventionId}/history`
    )
    .then((response) => response.data);


export const assignTechnician = (
  interventionId,
  technicianId
) =>
  api
    .patch(
      `/gmao/interventions/${interventionId}/technician`,
      {
        technician_id: technicianId || null,
      }
    )
    .then((response) => response.data);


export const transitionIntervention = (
  interventionId,
  status,
  note = ""
) =>
  api
    .post(
      `/gmao/interventions/${interventionId}/transition`,
      {
        status,
        note,
      }
    )
    .then((response) => response.data);


export const sendInstallationReport = (interventionId) =>
  api.post(`/gmao/interventions/${encodeURIComponent(interventionId)}/send-installation-report`)
    .then((response) => response.data);

export const completeInstallation = (interventionId, workPerformed) =>
  api.post(
    `/gmao/interventions/${encodeURIComponent(interventionId)}/complete-installation`,
    { work_performed: workPerformed }
  ).then((response) => response.data);

export const updateInterventionWorkReport = (
  interventionId,
  payload
) =>
  api
    .patch(
      `/gmao/interventions/${interventionId}/work-report`,
      payload
    )
    .then((response) => response.data);


export const listInterventionAttachments = (
  interventionId
) =>
  api
    .get(
      `/gmao/interventions/${interventionId}/attachments`
    )
    .then((response) => response.data);


export const uploadInterventionAttachment = (
  interventionId,
  file,
  kind = "photo",
  customerName = ""
) => {
  const formData = new FormData();

  formData.append(
    "file",
    file
  );

  formData.append(
    "kind",
    kind
  );

  formData.append(
    "customer_name",
    customerName
  );

  return api
    .post(
      `/gmao/interventions/${interventionId}/attachments`,
      formData
    )
    .then((response) => response.data);
};


export const getInterventionAttachmentBlob = (
  interventionId,
  attachmentId
) =>
  api
    .get(
      `/gmao/interventions/${interventionId}/attachments/${attachmentId}/file`,
      {
        responseType: "blob",
      }
    )
    .then((response) => response.data);


export const deleteInterventionAttachment = (
  interventionId,
  attachmentId
) =>
  api
    .delete(
      `/gmao/interventions/${interventionId}/attachments/${attachmentId}`
    )
    .then((response) => response.data);


export const listParts = (params = {}) =>
  api
    .get(
      "/gmao/parts",
      {
        params: cleanParams(params),
      }
    )
    .then((response) => response.data);


export const getStockSummary = () =>
  api
    .get("/gmao/parts/summary")
    .then((response) => response.data);


export const getPart = (partId) =>
  api
    .get(
      `/gmao/parts/${encodeURIComponent(partId)}`
    )
    .then((response) => response.data);


export const createPart = (payload) =>
  api
    .post(
      "/gmao/parts",
      payload
    )
    .then((response) => response.data);


export const updatePart = (
  partId,
  payload
) =>
  api
    .patch(
      `/gmao/parts/${encodeURIComponent(partId)}`,
      payload
    )
    .then((response) => response.data);


export const archivePart = (partId) =>
  api
    .post(
      `/gmao/parts/${encodeURIComponent(partId)}/archive`
    )
    .then((response) => response.data);


export const restorePart = (partId) =>
  api
    .post(
      `/gmao/parts/${encodeURIComponent(partId)}/restore`
    )
    .then((response) => response.data);


export const listPartMovements = (
  partId,
  params = {}
) =>
  api
    .get(
      `/gmao/parts/${encodeURIComponent(partId)}/movements`,
      {
        params: cleanParams(params),
      }
    )
    .then((response) => response.data);


export const receivePart = (
  partId,
  payload
) =>
  api
    .post(
      `/gmao/parts/${encodeURIComponent(partId)}/receive`,
      payload
    )
    .then((response) => response.data);


export const adjustPart = (
  partId,
  payload
) =>
  api
    .post(
      `/gmao/parts/${encodeURIComponent(partId)}/adjust`,
      payload
    )
    .then((response) => response.data);



export const listInterventionPartUsages = (
  interventionId,
  params = {}
) =>
  api
    .get(
      `/gmao/interventions/${encodeURIComponent(
        interventionId
      )}/part-usages`,
      {
        params: cleanParams(params),
      }
    )
    .then((response) => response.data);


export const consumeInterventionPart = (
  interventionId,
  payload
) =>
  api
    .post(
      `/gmao/interventions/${encodeURIComponent(
        interventionId
      )}/parts/consume`,
      payload
    )
    .then((response) => response.data);


export const returnInterventionPartUsage = (
  interventionId,
  usageId,
  payload = {}
) =>
  api
    .post(
      `/gmao/interventions/${encodeURIComponent(
        interventionId
      )}/part-usages/${encodeURIComponent(
        usageId
      )}/return`,
      payload
    )
    .then((response) => response.data);


export const getDashboard = (
  params = {}
) =>
  api
    .get(
      "/gmao/dashboard",
      {
        params: cleanParams(params),
      }
    )
    .then(
      (response) =>
        response.data
    );


export const listMaintenancePlans = (
  params = {}
) =>
  api
    .get(
      "/gmao/maintenance-plans",
      {
        params: cleanParams(params),
      }
    )
    .then(
      (response) =>
        response.data
    );


export const getMaintenancePlan = (
  planId
) =>
  api
    .get(
      `/gmao/maintenance-plans/${encodeURIComponent(
        planId
      )}`
    )
    .then(
      (response) =>
        response.data
    );


export const createMaintenancePlan = (
  payload
) =>
  api
    .post(
      "/gmao/maintenance-plans",
      payload
    )
    .then(
      (response) =>
        response.data
    );


export const updateMaintenancePlan = (
  planId,
  payload
) =>
  api
    .patch(
      `/gmao/maintenance-plans/${encodeURIComponent(
        planId
      )}`,
      payload
    )
    .then(
      (response) =>
        response.data
    );


export const deactivateMaintenancePlan = (
  planId
) =>
  api
    .post(
      `/gmao/maintenance-plans/${encodeURIComponent(
        planId
      )}/deactivate`
    )
    .then(
      (response) =>
        response.data
    );


export const activateMaintenancePlan = (
  planId
) =>
  api
    .post(
      `/gmao/maintenance-plans/${encodeURIComponent(
        planId
      )}/activate`
    )
    .then(
      (response) =>
        response.data
    );


export const generateMaintenanceIntervention = (
  planId,
  payload = {}
) =>
  api
    .post(
      `/gmao/maintenance-plans/${encodeURIComponent(
        planId
      )}/generate`,
      payload
    )
    .then(
      (response) =>
        response.data
    );


export const updateMachineMeter = (
  machineId,
  payload
) =>
  api
    .patch(
      `/gmao/machines/${encodeURIComponent(
        machineId
      )}/meter`,
      payload
    )
    .then(
      (response) =>
        response.data
    );


export const getInterventionReportPdfBlob = (
  interventionId
) =>
  api
    .get(
      `/gmao/interventions/${encodeURIComponent(
        interventionId
      )}/report.pdf`,
      {
        responseType: "blob",
      }
    )
    .then(
      (response) =>
        response.data
    );



// acta_patch_lot3_7_maintenance_quote_alerts_v1
export const createMaintenanceQuote = (
  planId,
  payload = {}
) =>
  api
    .post(
      `/gmao/maintenance-plans/${encodeURIComponent(
        planId
      )}/quote`,
      payload
    )
    .then(
      (response) =>
        response.data
    );



// acta_patch_lot3_8_delivery_intervention_docs_v1
export const archiveInterventionReport = (
  interventionId
) =>
  api
    .post(
      `/gmao/interventions/${encodeURIComponent(
        interventionId
      )}/archive-report`
    )
    .then(
      (response) =>
        response.data
    );



// acta_patch_lot3_9_qr_sav_v1
export const getMachineSavLink = (
  machineId
) =>
  api
    .get(
      `/gmao/machines/${encodeURIComponent(
        machineId
      )}/sav-link`
    )
    .then((response) => response.data);


export const getMachineSavQrSvgBlob = (
  machineId
) =>
  api
    .get(
      `/gmao/machines/${encodeURIComponent(
        machineId
      )}/sav-qr.svg`,
      {
        responseType: "blob",
      }
    )
    .then((response) => response.data);



// acta_patch_lot3_10_sav_ticket_lifecycle_v1
export const listSavTickets = (params = {}) =>
  api
    .get("/gmao/sav-tickets", { params: cleanParams(params) })
    .then((response) => response.data);

export const createSavTicket = (payload) =>
  api
    .post("/gmao/sav-tickets", payload)
    .then((response) => response.data);


export const createSavTicketIntervention = (
  ticketId
) =>
  api
    .post(
      `/gmao/sav-tickets/${ticketId}/intervention`
    )
    .then((response) => response.data);

export const getSavTicket = (ticketId) =>
  api
    .get(`/gmao/sav-tickets/${encodeURIComponent(ticketId)}`)
    .then((response) => response.data);

export const getSavTicketHistory = (ticketId) =>
  api
    .get(`/gmao/sav-tickets/${encodeURIComponent(ticketId)}/history`)
    .then((response) => response.data);

export const takeSavTicket = (ticketId) =>
  api
    .post(`/gmao/sav-tickets/${encodeURIComponent(ticketId)}/take`)
    .then((response) => response.data);

export const assignSavTicketTechnician = (ticketId, technicianId, note = "") =>
  api
    .patch(`/gmao/sav-tickets/${encodeURIComponent(ticketId)}/technician`, {
      technician_id: technicianId || null,
      note,
    })
    .then((response) => response.data);

export const updateSavTicketStatus = (ticketId, status, note = "") =>
  api
    .patch(`/gmao/sav-tickets/${encodeURIComponent(ticketId)}/status`, {
      status,
      note,
    })
    .then((response) => response.data);

export const addSavTicketComment = (ticketId, note) =>
  api
    .post(`/gmao/sav-tickets/${encodeURIComponent(ticketId)}/comments`, {
      note,
    })
    .then((response) => response.data);



// acta_patch_lot3_11_sav_attachments_dashboard_v1
export const listSavTicketAttachments = (ticketId) =>
  api
    .get(`/gmao/sav-tickets/${encodeURIComponent(ticketId)}/attachments`)
    .then((response) => response.data);

export const getSavTicketAttachmentBlob = (ticketId, attachmentId) =>
  api
    .get(
      `/gmao/sav-tickets/${encodeURIComponent(ticketId)}/attachments/${encodeURIComponent(attachmentId)}/file`,
      {
        responseType: "blob",
      }
    )
    .then((response) => response.data);


// acta_patch_us_gmao_019_sav_quote_v1
export const getSavTicketQuote = (
  ticketId
) =>
  api
    .get(
      `/gmao/sav-tickets/${encodeURIComponent(
        ticketId
      )}/quote`
    )
    .then(
      (response) =>
        response.data
    );


// acta_patch_us_gmao_017_rma_v1
export const listSavTicketRmaCases = (
  ticketId
) =>
  api
    .get(
      `/gmao/sav-tickets/${encodeURIComponent(
        ticketId
      )}/rma`
    )
    .then(
      (response) =>
        response.data
    );


export const createSavTicketRma = (
  ticketId,
  payload
) =>
  api
    .post(
      `/gmao/sav-tickets/${encodeURIComponent(
        ticketId
      )}/rma`,
      payload
    )
    .then(
      (response) =>
        response.data
    );


export const updateSavTicketRma = (
  ticketId,
  rmaId,
  payload
) =>
  api
    .patch(
      `/gmao/sav-tickets/${encodeURIComponent(
        ticketId
      )}/rma/${encodeURIComponent(
        rmaId
      )}`,
      payload
    )
    .then(
      (response) =>
        response.data
    );


export const getSavTicketRmaHistory = (
  ticketId,
  rmaId
) =>
  api
    .get(
      `/gmao/sav-tickets/${encodeURIComponent(
        ticketId
      )}/rma/${encodeURIComponent(
        rmaId
      )}/history`
    )
    .then(
      (response) =>
        response.data
    );


// ACTA_GMAO_INSTALLATIONS_V2
export const getInstallationOptions = () =>
  api
    .get("/gmao/installations/options")
    .then((response) => response.data);

export const listInstallations = (
  params = {},
  config = {}
) =>
  api
    .get(
      "/gmao/installations",
      {
        ...config,
        params: cleanParams(params),
      }
    )
    .then((response) => response.data);

export const getInstallation = (installationId) =>
  api
    .get(
      `/gmao/installations/${encodeURIComponent(
        installationId
      )}`
    )
    .then((response) => response.data);

export const getInstallationHistory = (
  installationId
) =>
  api
    .get(
      `/gmao/installations/${encodeURIComponent(
        installationId
      )}/history`
    )
    .then((response) => response.data);

export const createInstallation = (payload) =>
  api
    .post("/gmao/installations", payload)
    .then((response) => response.data);

export const createInstallationQuickClient = (
  payload
) =>
  api
    .post(
      "/gmao/installations/clients/quick",
      payload
    )
    .then(
      (response) =>
        response.data
    );

export const uploadInstallationDeliveryNote = (
  installationId,
  file
) => {
  const formData = new FormData();
  formData.append("file", file);

  return api
    .post(
      `/gmao/installations/${encodeURIComponent(
        installationId
      )}/delivery-note`,
      formData
    )
    .then((response) => response.data);
};


export const generateInstallationDeliveryNote = (
  installationId
) =>
  api
    .post(
      `/gmao/installations/${encodeURIComponent(
        installationId
      )}/delivery-note/generate`
    )
    .then((response) => response.data);


export const shareInstallationDeliveryNote = (
  installationId,
  payload
) =>
  api
    .post(
      `/gmao/installations/${encodeURIComponent(
        installationId
      )}/delivery-note/share`,
      payload
    )
    .then((response) => response.data);


export const getInstallationDeliveryNoteBlob = (
  installationId
) =>
  api
    .get(
      `/gmao/installations/${encodeURIComponent(
        installationId
      )}/delivery-note/file`,
      { responseType: "blob" }
    )
    .then((response) => response.data);


export const deleteInstallationDeliveryNote = (
  installationId
) =>
  api
    .delete(
      `/gmao/installations/${encodeURIComponent(
        installationId
      )}/delivery-note`
    )
    .then((response) => response.data);

export const scheduleInstallation = (
  installationId,
  payload
) =>
  api
    .post(
      `/gmao/installations/${encodeURIComponent(
        installationId
      )}/schedule`,
      payload
    )
    .then((response) => response.data);
